module.exports = __webpack_public_path__ + "static/404-mobile-3dab1e66bc278b67967ac8e6fb9d0a68.png";